import { selectUserAccountsEnabled } from '@/app/state/app-state/app-state.selectors';
import { State } from '@state/model';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AppDialogsService } from '@/app/services/app-dialogs.service';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-content-placeholder',
    template: `
        <div class="content-placeholder-message">
            <ng-container *ngIf="!icon">
                <ng-container *ngIf="type === 'no-results'">
                    <mat-icon class="glass">search</mat-icon>
                    <mat-icon>crop_free</mat-icon>
                </ng-container>
                <mat-icon *ngIf="type === 'error'">error_outline</mat-icon>
                <mat-icon *ngIf="type === 'loading'">hourglass_empty</mat-icon>
                <mat-icon *ngIf="type === 'sign-in'">account_circle</mat-icon>
            </ng-container>

            <mat-icon *ngIf="icon">{{ icon }}</mat-icon>

            <div class="text">
                <ng-content></ng-content>
                <p>
                    <ng-container *ngIf="type === 'no-results'">
                        {{ customMessage ? customMessage : "Nothing found" }}
                    </ng-container>
                    <ng-container *ngIf="type === 'error'">
                        {{ customMessage ? customMessage : "Error loading content." }}
                        <a href *ngIf="showRetry" (click)="$event.preventDefault(); retry.emit()">Retry</a>
                    </ng-container>
                    <ng-container *ngIf="type === 'loading'">
                        {{ customMessage ? customMessage : "Loading content. Please, wait..." }}
                    </ng-container>
                    <ng-container *ngIf="type === 'sign-in'">
                        <ng-container *ngIf="accountsEnabled$ | async; else accountsDisabled">
                            {{ customMessage ? customMessage : "This content is only available to signed in users." }}
                            <a href (click)="$event.preventDefault(); signIn()">Sign In</a>
                        </ng-container>
                        <ng-template #accountsDisabled>
                            {{ customMessage ? customMessage : "This content is not available." }}
                        </ng-template>
                    </ng-container>
                </p>
            </div>
        </div>
    `,
    styleUrls: ['./content-placeholder.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentPlaceholderComponent
{
    constructor
    (
        // Dependencies

        private readonly store: Store<State>,
        private readonly appDialogsService: AppDialogsService,
    )
    {}


    // Type

    @Input() protected type: 'no-results' | 'error' | 'sign-in' | 'loading' = 'no-results';


    // Customizations

    @Input() protected icon?: string;
    @Input() protected customMessage?: string;

    @Input() protected showRetry = false;
    @Output() protected readonly retry: EventEmitter<void> = new EventEmitter<void>();


    // Services state

    protected readonly accountsEnabled$ = this.store.select(selectUserAccountsEnabled);


    // Sign in dialog

    protected signIn() { this.appDialogsService.signIn(); }
}
